<template>
  <div class="layout">
    <el-container>
      <el-aside :width="collapse ? '100px' : '215px'">
        <div class="top">
          <div class="img">
            <img
              src="http://store-tiktok.oss-cn-beijing.aliyuncs.com/mini/images/1680140741992149.png"
              alt=""
            />
          </div>
          <h2>二当家</h2>
        </div>
        <el-menu
          :collapse="collapse"
          unique-opened
          router
          :default-active="defactive"
          class="el-menu-vertical-demo"
          text-color="#fff"
          active-text-color="#FF626D"
        >
          <el-menu-item class="home" index="/home">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>

          <el-submenu index="/master">
            <template slot="title">
              <img class="img" src="../../static/img/master.png" alt="" />
              <span>达人管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/master/list">达人列表</el-menu-item>
              <el-menu-item index="/master/list/info">达人信息</el-menu-item>
              <el-menu-item index="/master/verify">达人审核</el-menu-item>
              <el-menu-item index="/master/tiktok">平台信息</el-menu-item>
              <el-menu-item index="/master/changeMoney"  v-if="canAccessChangeMoney">余额变更</el-menu-item>
              <el-menu-item index="/master/record">操作记录</el-menu-item>
              <el-menu-item index="/master/addUser">添加用户</el-menu-item>
              <el-menu-item index="/master/userRecord">用户操作记录</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/provider">
            <template slot="title">
              <img class="img" src="../../static/img/provider.png" alt="" />
              <span>服务商管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/provider/list">服务商列表</el-menu-item>
              <el-menu-item index="/provider/verify">服务商审核</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/task">
            <template slot="title">
              <img class="img" src="../../static/img/task.png" alt="" />
              <span>任务管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/task/orders">全部订单</el-menu-item>
              <el-menu-item index="/task/cancelOrder">订单取消</el-menu-item>
              <el-menu-item index="/task/cloud">云探任务</el-menu-item>
              <el-menu-item index="/task/store">实探任务</el-menu-item>
              <el-menu-item index="/task/offline">实探线下</el-menu-item>
              <el-menu-item index="/task/qrcode">扫码直发</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/operation">
            <template slot="title">
              <img class="img" src="../../static/img/operation.png" alt="" />
              <span>运营管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/operation/top">任务排序</el-menu-item>
              <el-menu-item index="/operation/banner">banner配置</el-menu-item>
              <el-menu-item index="/operation/socialCommunity"
                >社群配置</el-menu-item
              >
              <el-menu-item index="/operation/inviteFriend"
                >邀请好友</el-menu-item
              >
              <el-menu-item index="/operation/infoClassify">
                资讯分类
              </el-menu-item>
              <el-menu-item index="/operation/infoManage">
                资讯管理
              </el-menu-item>
              <el-menu-item index="/operation/exportRecord">
                导出记录
              </el-menu-item>
              <el-menu-item index="/operation/noticeManage">
                公告管理
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/config">
            <template slot="title">
              <i class="el-icon-set-up"></i>

              <span>配置管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/config/distributor">
                分销商配置
              </el-menu-item>
              <el-menu-item v-if="user.name == 'admin'" index="/config/money">
                任务金配置
              </el-menu-item>
              <el-menu-item index="/config/autoCancel"> 任务配置 </el-menu-item>
              <el-menu-item index="/config/customer"> 客服配置 </el-menu-item>
              <el-menu-item
                index="/config/limitWithdrawal"
                v-if="user.name == 'admin'"
              >
                提现配置
              </el-menu-item>
              <el-menu-item index="/config/link"> 链接设置 </el-menu-item>
              <el-menu-item index="/config/producPackage">
                产品包设置
              </el-menu-item>
              <el-menu-item index="/config/productClass">
                产品分类
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/asset">
            <template slot="title">
              <img class="img" src="../../static/img/finance.png" alt="" />
              <span>资金管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/asset/withdrawalVerify" v-if="canAccessChangeMoney"
                >达人提现审核</el-menu-item
              >
              <el-menu-item index="/asset/serviceWithdrawal" v-if="canAccessChangeMoney"
                >服务商提现审核</el-menu-item
              >
              <el-menu-item index="/asset/master">达人明细</el-menu-item>
              <el-menu-item index="/asset/provider">服务商明细</el-menu-item>
              <el-menu-item index="/asset/balanceAdjustment" v-if="canAccessBalanceAdjustment"
                >商家/服务商余额变更</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/finance" v-if="canAccessChangeMoney">
            <template slot="title">
              <i class="el-icon-data-analysis"></i>
              <span>财务审计</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/finance/dashboard">资金大盘</el-menu-item>
              <el-menu-item index="/finance/userProfile">用户画像</el-menu-item>
              <el-menu-item index="/finance/freeze">冻结/白名单</el-menu-item>
              <el-menu-item index="/finance/alerts">告警工作台</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/report">
            <template slot="title">
              <i class="el-icon-files"></i>

              <span>报表管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/report/day">日报表</el-menu-item>
              <el-menu-item index="/report/task">任务报表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/system">
            <template slot="title">
              <img class="img" src="../../static/img/system.png" alt="" />
              <span>系统管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/system/user">用户管理</el-menu-item>
              <el-menu-item index="/system/loginLog">登录日志</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="(v, i) in bread" :key="i" :to="v.to">{{
              v.title
            }}</el-breadcrumb-item>
          </el-breadcrumb>

          <div class="right">
            <el-avatar :size="42" :src="user.avatar"></el-avatar>
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link">
                {{ user.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-main
          ><!-- 二级出口 -->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { api_admin_info } from "@/api/users";

const BALANCE_ADJUSTMENT_ACCOUNTS = [
  "admin",
  "fengqian",
  "caiwu2",
  "15775768153",
  "19508190726",
  "14702801532",
  "15228021695",
  "13551730466",
];

const BALANCE_ADJUSTMENT_NAMES = [
  "admin",
  "产品",
  "财务谢辉",
  "二当家财务",
  "红梅",
  "顾小色",
  "袁雪绮",
  "李顺骍",
];

export default {
  data () {
    return {
      collapse: false,
      bread: [],
      user: {
        name: "月球漫步",
        account: "",
        avatar:
          "http://store-tiktok.oss-cn-beijing.aliyuncs.com/mini/images/1680140741992149.png",
      },
    };
  },
  computed: {
    canAccessChangeMoney () {
      const allowedUsers = ['产品', 'admin','财务谢辉', '红梅', '顾小色', '王科梅', '袁雪绮', '李顺骍'];
      return allowedUsers.includes(this.user.name);
    },
    canAccessBalanceAdjustment () {
      return BALANCE_ADJUSTMENT_ACCOUNTS.includes(this.user.account) ||
        BALANCE_ADJUSTMENT_NAMES.includes(this.user.name);
    },
    defactive () {
      const routerPath = this.$route.path;
      const routerList = routerPath.split("/");
      if (routerList.length == 4) {
        routerList.pop();
        return routerList.join("/");
      } else {
        return routerPath;
      }
    },
  },
  created () {
    this.user.name = localStorage.getItem("userName");
    this.user.account = localStorage.getItem("userAccount") || "";
    this.callbread();
    this.getUserInfo();
    this.$bus.$on("updateInfo", () => {
      this.getUserInfo();
    });
  },
  watch: {
    $route () {
      this.callbread();
    },
  },
  methods: {
    getUserInfo () {
      api_admin_info().then((res) => {
        if (res.data.code !== 200 || !res.data.data) return;
        const user = res.data.data;
        this.user.name = user.name || this.user.name;
        this.user.account = user.account || this.user.account;
        localStorage.setItem("userName", this.user.name || "");
        localStorage.setItem("userAccount", this.user.account || "");
        if (this.$route.path === "/asset/balanceAdjustment" && !this.canAccessBalanceAdjustment) {
          this.$message.error("无权访问余额变更页面");
          this.$router.replace("/asset/provider");
        }
      }).catch(() => {});
    },
    handleCollapse () {
      this.collapse = !this.collapse;
    },
    callbread () {
      const matched = this.$route.matched.filter((v) => v && v.meta && v.meta.title);
      this.bread = matched.map((v) => ({ title: v.meta.title, to: v.path }));
    },
    handleCommand (type) {
      if (type === "logout") {
        localStorage.clear();
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.layout .el-container .el-aside .el-menu[data-v-5d5a9732] .el-submenu__title i {
  font-size: 24px;
}

.layout {
  height: 100%;
  background-color: #f3f4ff;

  .el-container {
    overflow: hidden;

    i {
      color: #fff;
    }

    .hide {
      display: none;
    }

    .el-header {
      padding: 0;
      display: flex;
      background-color: #fff;
      margin-bottom: 3px;

      .title {
        display: flex;
        align-items: center;
        margin-right: 20px;

        img {
          width: 44px;
          height: 44px;
        }

        p {
          font-size: 22px;
          color: #333333;
        }
      }

      .el-breadcrumb {
        margin-left: 20px;
        flex: 1;
        display: flex;
        align-items: center;

        i {
          font-size: 20px;
          margin-right: 20px;
        }

        /deep/ .el-breadcrumb__separator {
          color: #ff5f6d;
        }
      }

      .right {
        display: flex;
        align-items: center;
        margin-right: 30px;

        i {
          font-size: 20px;
          color: #666666;
        }

        .el-avatar--circle {
          margin-right: 24px;
        }

        .el-dropdown {
          i {
            margin-left: 10px;
          }
        }
      }
    }

    height: 100%;

    .el-aside {
      height: 100%;
      background: linear-gradient(42deg, #ff5f6d 0%, #fe846c 100%) !important;

      .top {
        display: flex;
        align-items: center;
        padding-left: 30px;
        margin: 25px 0 30px 0;

        .img {
          width: 60px;
          height: 60px;
          background: #ffffff;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;

          img {
            padding-left: 5px;
          }
        }

        h2 {
          color: #fff;
          letter-spacing: 3.2px;
        }
      }

      .el-menu {
        border: none;
        border-right: none;
        background: transparent;

        .el-submenu {
          margin-bottom: 10px;

          .img {
            width: 26px;
            height: 26px;
          }
        }

        /deep/ .el-submenu .el-menu {
          background: transparent;
        }

        .el-submenu__title * {
          font-size: 16px;
          margin-left: 14px;
        }

        /deep/ .el-submenu__title {
          letter-spacing: 1.2px;
        }

        /deep/ .el-submenu__title:hover {
          background: rgba(0, 0, 0, 0.2);
        }

        /deep/ .el-submenu__title i {
          color: #fff !important;
        }

        .el-menu-item {
          min-width: none;
          padding-left: 81px !important;
          text-align: left;

          &.home {
            margin-bottom: 10px;
            font-size: 16px;
            padding-left: 34px !important;
            text-align: left;
            letter-spacing: 2px;

            i {
              font-size: 26px;
              margin-right: 26px;
            }

            &:hover {
              color: #fff !important;
            }

            &.is-active {
              color: #ff5f6d !important;
            }
          }
        }

        .el-menu-item:hover {
          background: rgba(0, 0, 0, 0.3) !important;
        }

        .el-menu-item.is-active {
          background: #f3f4ff !important;
          border-radius: 30px 0px 0px 30px;
        }

        .el-menu-item.is-active i {
          color: #ff626d !important;
        }
      }
    }

    .el-main {
      background: #f3f4ff;
      overflow: auto;
      padding: 20px 20px 0 20px;
    }
  }
}
</style>
